"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const usePostMessage_1 = require("./usePostMessage");
function useCloseWebView() {
    return (0, usePostMessage_1.default)('closeWebView');
}
exports.default = useCloseWebView;
